<template>
    <div>
        <validation-observer ref="radioForm">
            <div class="form-group p-0-14">
                <validation-provider v-slot="{errors}" :rules="attribute.mandatory ? 'required' : ''">
                    <div v-if="attribute" class="radio-btn-attribute">
                        <label :for="id" class="attribute-label">
                            {{ attribute.attribute_name }}
                            <a v-if="removeTags(attribute.extra_info) !== ''"
                               :data-content="popover_custom_data(attribute.extra_info)" data-html="true" data-placement="bottom"
                               data-toggle="popover"
                               href="javascript:;"
                            class="helper-icon-a"> <i class="fa fa-info-circle"></i></a>
                        </label>

                        <div v-for="(value,index) of attribute.attribute_values" :key="index">
                            <input :id="id+index"
                                   :checked="value && selected && selected.attribute_value_id == value.attribute_value_id"
                                   :name="name"
                                   type="radio"
                                   @click="onClick(value)">
                            <label :for="id+index">
                                {{ value.attribute_value }}
                            </label>

                            <span  class="cost-attribute"  style="text-align: left;">
                                     <span  class="unit_priceunit_price"  v-if="value.unit_price && parseFloat(value.unit_price) > 0" >
                                               +{{ priceText(value.unit_price, value.cost_type,currency,unit) }}
                                     </span>
                                     <span  class="attribute_additional_timeData" v-if="value.additional_time">
                                           {{ callAdditionalTimeTextData(value.additional_time )    }}
                                     </span>
                            </span>
                        </div>

                    </div>
                    <div v-if="selected && selected.hasOwnProperty('attribute_value_id')" class="display-none">
                        <input :id="`${id}`" :name="name" :value="selected.attribute_value_id" type="hidden">
                    </div>

                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </validation-observer>
        <div v-if="dependency.length > 0" class="form-group p-0-14">
            <div v-for="(dependent,index) of dependency" :key="dependent.attribute_id">
                <attribute v-model="dependency[index]"
                           :attributes="attributes"
                           :clone="clone"
                           :currency="currency"
                           :date-format="dateFormat"
                           :time-format="timeFormat"
                           :unit="unit">

                </attribute>
            </div>
        </div>
    </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {priceText} from "@/events/sharedMethods.js";

export default {
    name: "RadioButtonAttribute",
    props: {
        attributes: {
            type: Array,
            default() {
                return []
            }
        },
        attribute: {
            type: Object,
            required: true
        },
        value: {},
        dateFormat: null,
        timeFormat: null,
        clone: 0,
        currency: {
            required: true
        },
        unit: {
            required: true
        }
        ,
        additionalTimeTextData:Function
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            selected: []
        }
    },
    computed: {
        /**
         * gets all dependencies of the selected attribute
         * @returns {T[]|*[]}
         */
        dependency() {
            if (this.selected && this.selected.dependency) {
                return this.attributes.filter(attribute => this.selected.dependency.includes(attribute.attribute_id))
            }
            return []
        },
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        }
    },
    methods: {
        addEventListeners() {


            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.radioForm.validate();
                if (!validated) {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService', this.attribute)

                }
                verify(validated)
            })


        }
        ,
        callAdditionalTimeTextData(val){
            return  this.additionalTimeTextData(val);
        }
        ,

        /**
         * pick a value
         * @param value
         */
        onClick(value) {
            let alreadySelected = false;
            if (this.selected == value) {
                alreadySelected = true;
            }

            // this.uncheck();
            if (!alreadySelected) {
                this.check(value)
            }

            this.$emit('input', this.selected);
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribute,
                value: this.selected
            })
        },
        uncheck() {
            this.selected = null
        },
        check(value) {
            if (this.selected && this.selected.dependency) {
                // remove selected depenancy on chosse another attribute
                let dependant_selected = this.attributes.filter(attribute => this.selected.dependency.includes(attribute.attribute_id))
                for (let dependant_selected_id of dependant_selected) {
                    dependant_selected_id.selected = null;
                }
            }
            this.selected = value
        },
        retrieveSelected() {
            if (this.attribute.service_attribute_value) {
                return this.attribute.attribute_values
                    .find(av => av.attribute_value_id == +this.attribute.service_attribute_value)
            }
            return this.attribute && Object.keys((this.attribute || {}).selected || {}) ? this.attribute.selected : {};
        },
        triggerChange() {
             EventBus.$emit('onServiceCustomFieldSelected',this.attribute.service_id,this.clone)       },
        priceText,
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            var DataToAdd=null
            if(div.textContent){
                DataToAdd= div.textContent
            }
            else if(div.innerText){
                DataToAdd= div.innerText
            }else{   DataToAdd= '';  }
            if(DataToAdd){
                return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
            }else {
                return DataToAdd;
            }            },
        popover_custom_data(value) {
            return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;;
        },
    },
    mounted() {
        this.addEventListeners()
        this.selected = this.retrieveSelected()
    },
    watch: {
        selected: {
            handler: function (data) {
                if (data && !Array.isArray(data))
                    this.$nextTick(() => {
                        this.attribute.selected = this.selected;
                      this.triggerChange()
                      console.log(this.attribute.selected.length)

                    });


            },
            deep: true
        },
        // dependency:{
        //     handler: function (data) {
        //         this.$emit('input', this.selected);
        //        },
        //     deep: true
        //     }
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
</style>